var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoursOfOperationFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 26,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAMAAAB1owf/AAAAAXNSR0IB2cksfwAAANtQTFRFAAAAn5+fpqa8r6q+rqq6q6u6kpK2rai9rau8rq29r62+r6y+rqy8rai7pKS2r6y8rq29rqy9r62+rqy+rqy9rKy6r6y+r6y9qqq2qqq1rqy9rq29rq29qqq4r6y+rqy+ra29q6u7r629r6u+rq29r62+r62+r6q9rqy9rqy9r6y+rqy8q6u8rqy9r6y9qqq7rqi7rqy+r6y9ra29rqy9rqy+r62+mZmzra29rq29rKy7r6y9rKy+r6y+r6y+r6y9rq29rq2+r62+rqi8r629r629r62+r62+r6y9dqwhDgAAAEl0Uk5TAAgXMz9DBzJqq//PfjgOXNz5/vOEJdvxFRjkqp4SnOofQOiJ2e/7Nnv9mYo9kNUPKZTSYO32lQpdzUfFK7y49LHTZiZ/5evMbColHbAAAADESURBVHicfdLXGoIwDIDRIIgYB4oDN+6Finvv/f5PJMpXFYj+d825ahuAV5yH5wWvwPMeDr4TfZIfrQLBkPiBsByJIkuJxRNvkZNoS5VSFqQz6Cz7olTOBYiSCfkCAagVAUplSlAGqJCAVYAaLSoHNGC98UuUJrR+UPuPRGlQdKCvg2oHurT0DOjTMjAfbkhBpG/KaOyGyXT2/Oq5WxZLawtWLlmz3+7Z5xsGIIa2uy/Qw7at2rP54QjOTueLdr3dDXZ+ABAoHg4qBY7WAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0430\\u043F\\u043A\\u0430 1"
  }, /*#__PURE__*/React.createElement("use", {
    id: "\\u0421\\u043B\\u043E\\u0439 1",
    href: "#img1",
    x: 1,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M26 13C26 20.18 20.18 26 13 26C5.82 26 0 20.18 0 13C0 5.82 5.82 0 13 0C20.18 0 26 5.82 26 13ZM13 1C6.37 1 1 6.37 1 13C1 19.63 6.37 25 13 25C19.63 25 25 19.63 25 13C25 6.37 19.63 1 13 1ZM13.5 7L13.5 14.5L18 14.5L18 15.5L12.5 15.5L12.5 7L13.5 7Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursOfOperationFilled);
export default __webpack_public_path__ + "static/media/hours-of-operation-filled.4bfdbfa0.svg";
export { ForwardRef as ReactComponent };